import React, { useState, useEffect } from 'react';
import axiosInstance from '../utils/axios';
import '../styles/HeaderNewsTicker.scss';

const HeaderNewsTicker = () => {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchFlashNews = async () => {
      try {
        const response = await axiosInstance.get('/news_and_events/flash-news/get_flash_news');
        setNews(response.data);
      } catch (err) {
        // setError('Failed to load news');
        console.error('Error fetching flash news:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchFlashNews();
  }, []);

  if (loading) return <div className="news-ticker">Loading news...</div>;
  if (error) return <div className="news-ticker">{error}</div>;
  if (!news.length) return <div></div>;

  return (
    <div className="news-ticker">
      <div className="ticker-wrapper">
        <div className="ticker-content">
          {news.map((item, index) => (
            <span key={item.id || index} className="ticker-item">
              • {item.content}. 
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HeaderNewsTicker;
